import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '', website: '' });
  const formLoadedAtRef = useRef(Date.now());
  const [status, setStatus] = useState(''); // 'sending' | 'sent' | 'error'
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await api.post('/contact', { ...form, formLoadedAt: formLoadedAtRef.current });
      setStatus('sent');
      setForm({ name: '', email: '', subject: '', message: '', website: '' });
      formLoadedAtRef.current = Date.now();
    } catch {
      setStatus('error');
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb',
    borderRadius: 8, fontSize: 14, boxSizing: 'border-box', transition: 'border-color 0.2s',
  };

  return (
    <div className="container" style={{ maxWidth: 820 }}>
      <h1 style={{ marginBottom: 6 }}>Contact Us</h1>
      <p style={{ color: '#6b7280', marginBottom: 36 }}>We'd love to hear from you. Fill out the form below and we'll get back to you within 1–2 business days.</p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, alignItems: 'start' }}>

        {/* Form */}
        <div style={{ background: 'white', padding: 28, borderRadius: 12, border: '1px solid #e5e7eb' }}>
          {status === 'sent' ? (
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
              <h2 style={{ marginBottom: 8 }}>Message Sent!</h2>
              <p style={{ color: '#6b7280' }}>Thank you for reaching out. We'll get back to you within 1–2 business days.</p>
              <button className="btn btn-outline" style={{ marginTop: 20 }} onClick={() => setStatus('')}>Send another message</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={form.website}
                onChange={e => set('website', e.target.value)}
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
                style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none' }}
              />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Your Name *</label>
                  <input style={inputStyle} value={form.name} onChange={e => set('name', e.target.value)} placeholder="Jane Doe" required />
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Email Address *</label>
                  <input style={inputStyle} type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="jane@example.com" required />
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Subject *</label>
                <select style={inputStyle} value={form.subject} onChange={e => set('subject', e.target.value)} required>
                  <option value="">Select a topic...</option>
                  <option value="Order Issue">Order Issue</option>
                  <option value="Return / Refund">Return / Refund</option>
                  <option value="Shipping Question">Shipping Question</option>
                  <option value="Product Question">Product Question</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Message *</label>
                <textarea
                  style={{ ...inputStyle, minHeight: 140, resize: 'vertical' }}
                  value={form.message}
                  onChange={e => set('message', e.target.value)}
                  placeholder="Tell us how we can help..."
                  required
                />
              </div>
              {status === 'error' && (
                <div style={{ marginBottom: 14, padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, color: '#991b1b', fontSize: 13 }}>
                  Something went wrong. Please try emailing us directly at support@styleme.club
                </div>
              )}
              <button className="btn btn-primary" type="submit" style={{ width: '100%' }} disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>

        {/* Contact info */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {[
            { icon: '📧', title: 'Email', body: 'support@styleme.club', sub: 'We respond within 1–2 business days' },
            { icon: '🚚', title: 'Shipping', body: '2–7 business days', sub: 'Standard US shipping' },
            { icon: '↩️', title: 'Returns', body: '30-day return window', sub: <Link to="/returns" style={{ color: '#6b7280', fontSize: 12 }}>See our Returns & Refunds policy</Link> },
            { icon: '🕐', title: 'Support Hours', body: 'Mon – Fri, 9am – 6pm EST', sub: '' },
          ].map(({ icon, title, body, sub }) => (
            <div key={title} style={{ background: 'white', padding: '18px 20px', borderRadius: 10, border: '1px solid #e5e7eb', display: 'flex', gap: 16, alignItems: 'flex-start' }}>
              <span style={{ fontSize: 28 }}>{icon}</span>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 2 }}>{title}</div>
                <div style={{ fontSize: 14, color: '#374151' }}>{body}</div>
                {sub && <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{sub}</div>}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
